import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PromiseCreator from 'promise-creator';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import {
    mergeAccountAction,
    sendMergeRequestAction,
    closeMergeRequestAction,
} from '../../redux/auth';
import styles from './MergeRequestModal.css';
import Input from '../Forms/Input';
import FormError from '../Forms/FormError';
import PasswordInput from '../Forms/PasswordInput';
import RadioButtons from '../Forms/RadioButtons';
import Button from '../Button';
import SecondaryButton from '../SecondaryButton';
import BackButton from '../BackButton';

const MergeRequestForm = ({
    secondaryEmailMissing,
    handleSubmit,
    closeMergeRequest,
    pristine,
    submitting,
    error,
    request,
}) => (<form
    onSubmit={handleSubmit}
>
    {secondaryEmailMissing ? <BackButton
        onClick={() => closeMergeRequest()}
    /> : null}
    <h2> Merge Account </h2>
    <p>
        {'An account with the email address you entered as your Secondary Email already exists. Enter the password for the account, or we can send an email to the provided address with instrutions to complete the merge process.'}
    </p>
    <FormError error={error} />
    <Field
        id="request-mode"
        name="request"
        component={RadioButtons}
        values={[{
            label: 'Enter Password',
            value: 'password',
        }, {
            label: 'Send Email',
            value: 'email',
        }]}
        className={styles.radios}
    />
    <div className={styles.row}>
        <Field
            name="email"
            component={Input}
            label="Email"
            disabled
            className={styles.input}
        />
        {request === 'password' ? <Field
            name="password"
            component={PasswordInput}
            label="Password"
            className={styles.input}
        /> : null}
    </div>
    <div className={styles.btnWrap}>
        {!secondaryEmailMissing ? <SecondaryButton
            onClick={() => closeMergeRequest()}
        >
            Cancel
        </SecondaryButton> : null}
        <Button loading={submitting} disabled={pristine} type="submit">
            {request === 'password' ? 'Merge Account' : 'Send Email'}
        </Button>
    </div>
</form>);

MergeRequestForm.propTypes = {
    secondaryEmailMissing: PropTypes.bool,
    error: PropTypes.string,
    submitting: PropTypes.bool,
    handleSubmit: PropTypes.func,
    closeMergeRequest: PropTypes.func,
    pristine: PropTypes.bool,
    request: PropTypes.string,
};

export default compose(
    connect(({ me, form, auth }, props) => ({
        secondaryEmailMissing: me && !me.secondaryEmail,
        initialValues: {
            email: auth.mergeRequestModal,
            request: 'password',
        },
        request: formValueSelector(props.form)({ form }, 'request'),
    }), {
        mergeAccount: mergeAccountAction,
        sendMergeRequest: sendMergeRequestAction,
        closeMergeRequest: closeMergeRequestAction,
    }),
    withHandlers({
        onSubmit: ({ mergeAccount, sendMergeRequest }) => ({ request, ...body }) => {
            const {
                promise,
                resolve,
                reject,
            } = PromiseCreator();
            if (request === 'password') {
                mergeAccount(body, { resolve, reject });
            } else {
                sendMergeRequest(body.email, { resolve, reject });
            }
            return promise;
        },
    }),
    reduxForm({
        enableReinitialize: true,
    }),
)(MergeRequestForm);



// WEBPACK FOOTER //
// ./src/client/Components/MergeRequestModal/MergeRequestForm.js